import { render, staticRenderFns } from "./NavbarColor.vue?vue&type=template&id=0c31e1b4&"
import script from "./NavbarColor.vue?vue&type=script&lang=js&"
export * from "./NavbarColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports